// AP Statistics - Index: All lessons combined

import { unit1Lessons } from './unit1Lessons';
import { unit2To9Lessons } from './unit2To9Lessons';

// Combine all lessons
export const allStatisticsLessons = [
  ...unit1Lessons,
  ...unit2To9Lessons
];

// Export lessons by unit for organized display
export const unitNames = [
  'Unit 1: Exploring One-Variable Data',
  'Unit 2: Exploring Two-Variable Data',
  'Unit 3: Collecting Data',
  'Unit 4: Probability, Random Variables, and Probability Distributions',
  'Unit 5: Sampling Distributions',
  'Unit 6: Inference for Categorical Data: Proportions',
  'Unit 7: Inference for Quantitative Data: Means',
  'Unit 8: Inference for Categorical Data: Chi-Square',
  'Unit 9: Inference for Quantitative Data: Slopes'
];

export default allStatisticsLessons;